import { useEffect, useRef } from 'react';
import './Preschool.css';
import { useOutletContext } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import Parser from 'html-react-parser';

function Preschool() {
    const pageJSON = useOutletContext()
    const subjectsRef = useRef(null)
    const engElem = useRef(null)
    const mathElem = useRef(null)
    const abaElem = useRef(null)
    const phoElem = useRef(null)
    const url_domain = pageJSON ? pageJSON["url_domain"] : null
    const htmlElement = document.documentElement

    useEffect(() => {    
        htmlElement.style.setProperty('--YELLOW-elem-height', engElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--BLUE-elem-height', mathElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--GREEN-elem-height', abaElem.current.offsetHeight + 'px');
        htmlElement.style.setProperty('--GRAY-elem-height', phoElem.current.offsetHeight + 'px');

        const observer = new IntersectionObserver(
            subjects => {
                for (let i = subjects.length - 1; i >= 0; i--) {
                    const subject = subjects[i]
                    console.log(subject.target.getBoundingClientRect().height)
                    if (subject.isIntersecting) {
                        subject.target.classList.add("opened")
                        observer.unobserve(subject.target)
                    }
                }
            },
            {
                "rootMargin": "-0px 0px -250px 0px",
                "threshold": 0.1
            }
        );

        const resize_observer = new ResizeObserver(
            subjects => {
                for (let i = subjects.length - 1; i >= 0; i--) {
                    const subject = subjects[i]
                    htmlElement.style.setProperty('--'+subject.target.classList[0]+'-elem-height', subject.target.getBoundingClientRect().height + 'px');
                }
            }
        );
        
        subjectsRef.current.querySelectorAll(".subject-contents-wrapper:not(.YELLOW)").forEach((subject) => {
            observer.observe(subject)
        })
        subjectsRef.current.querySelectorAll(".subject-contents-wrapper").forEach((subject) => {
            resize_observer.observe(subject)
        })
        return () => observer.disconnect();
    }, [])
    return (
        <div className="main">
            <div id='banner'>
                <img src='images/page-banners/preschool-banner.png' id='banner-img'/>
                <div id='banner-title'>Pre-school</div>
            </div>

            <div className='center-content'>
                <Breadcrumbs></Breadcrumbs>
                <div id='subject-stack-wrapper' ref={subjectsRef}>
                    <div className='YELLOW subject-contents-wrapper learn-more-hidden' ref={engElem} id='english-sub'>
                        <div className="subjects YELLOW subject-content-subject">
                            <h2>ENGLISH</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                                <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["preschool"]["ENGLISH"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["preschool"]["ENGLISH"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["preschool"]["ENGLISH"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["preschool"]["ENGLISH"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        engElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["preschool"]["ENGLISH"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='BLUE subject-contents-wrapper learn-more-hidden' id='math-sub' ref={mathElem}>
                        <div className="subjects BLUE subject-content-subject">
                            <h2>MATH</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                                <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["preschool"]["MATH"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["preschool"]["MATH"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["preschool"]["MATH"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["preschool"]["MATH"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        mathElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["preschool"]["MATH"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='GREEN subject-contents-wrapper learn-more-hidden' id='science-sub' ref={abaElem}>
                        <div className="subjects GREEN subject-content-subject">
                            <h2>ABACUS</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                            <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["preschool"]["ABACUS"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["preschool"]["ABACUS"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["preschool"]["ABACUS"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["preschool"]["ABACUS"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        abaElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["preschool"]["ABACUS"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='GRAY subject-contents-wrapper learn-more-hidden' id='chinese-sub' ref={phoElem}>
                        <div className="subjects GRAY subject-content-subject">
                            <h2>PHONICS</h2>
                        </div>
                        <div className="row-wrapper">
                            <div className='subject-content'>
                            <div className="subject-row grid">
                                    <div className="subject-row-image">
                                        <img src={pageJSON ? url_domain+pageJSON["preschool"]["PHONICS"]["img_url"] : null}></img>
                                    </div>
                                    <div className="subject-row-right">
                                        <div className="subject-title">
                                            {pageJSON ? Parser(pageJSON["preschool"]["PHONICS"]["title"]) : null}
                                        </div>
                                        <div className="subject-tutors">
                                            <p>Head Tutors:</p>
                                            <div className="subject-tutors-imgs">
                                                {pageJSON ? pageJSON["preschool"]["PHONICS"]["tutor_img_urls"].map((img_url, index) => {
                                                    return(<img src={url_domain+img_url} alt="" />)
                                                }) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <div className="subject-desc">
                                        {pageJSON ? Parser(pageJSON["preschool"]["PHONICS"]["content"]) : null}
                                    </div>
                                </div>
                                <div className="subject-row">
                                    <button className='learn-more-btn' onClick={() => {
                                        phoElem.current.classList.toggle("learn-more-hidden")
                                    }}>
                                        <i className="fa-solid fa-caret-up"></i><p>Learn More</p><i className="fa-solid fa-caret-up"></i>
                                    </button>
                                </div>
                                <div className="learn-more-div">
                                    <div className="learn-more-text">
                                        {pageJSON ? Parser(pageJSON["preschool"]["PHONICS"]["learn_more"]) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row-wrapper">
                        <button id='contact-us-btn' onClick={() => {
                            window.location.href="https://api.whatsapp.com/send?phone=6592350468"
                        }}>
                            Contact Us
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preschool;